import React, { PropTypes } from 'react'
import Dropzone from "react-dropzone";
import CsvExport from "csvexport";
import FontAwesome from "react-fontawesome";
import { kinetik_api_url} from "~/app/utilities";
import axios from 'axios';
import toastr from 'toastr';

import { Header, SideNavbar } from '../index';


class EdiConverter extends React.Component {

  handleDrop = (files) => {
    const file = files[0];
    const name = file.name;
    const reader = new FileReader();
    reader.onload = async () => {
      const fileAsBinaryString = reader.result;
      const ediFileType = fileAsBinaryString.split('~')[2].split('*')[1];
      let parsedData = {};
      let headers = [];
      if (ediFileType === '835') {
        parsedData = await this.get835Data(fileAsBinaryString);
        headers = headers835;
      } else if (ediFileType === '837') {
        parsedData = await this.get837Data(fileAsBinaryString);
        headers = headers837;
      }
      console.log('parsedData', parsedData);
        const exporter = CsvExport.create({ filename: name+".csv", columns: headers })
        exporter.downloadCsv(parsedData);
    };
    reader.onabort = () => console.log('file reading was aborted');
    reader.onerror = () => console.log('file reading has failed');

    reader.readAsBinaryString(file);
  }

  get835Data=async (ediString)=>{
    return axios.post(kinetik_api_url + "/edi/835", { data:ediString }).then((res,err) => {
      if (res.data.parsedData) {
        toastr.success("Downloading converted 835")
        return res.data.parsedData;
      }
      else {
        toastr.error("Conversion error!")
      }
    })
  }
  get837Data=async (string837)=>{
      return axios.post(kinetik_api_url + "/edi/837/parse", { data: string837 }).then(res => {
        return res.data;
      }).catch(err=>{
        console.log("err parsing 837",err);
      })
    
  }

  renderDropArea = () => {
    return (
      <Dropzone className="dropzone" onDrop={this.handleDrop}>
        <FontAwesome className="icon-cloud" name="cloud-upload" />
        <p className="upload-txt">
          Drag and Drop 835/837 File here <br /> <span>or</span>
        </p>
        <button type="button" className="btn btn-primary upload-btn">
          Browse Files
      </button>
      </Dropzone>
    )

  }

  render() {
    return (
      <div>
        <Header />
        <SideNavbar />
       
        <div className="body-content">
        <div className="page-title">835/837 to CSV Converter</div>
            <div className="page-subtitle"> File will download automatically once the conversion is complete </div> 
          <div >
           
            <div className="box-content edi835-dropzone">{this.renderDropArea()}</div>
          </div>
        </div>
      </div>
    )

  }
}

export default EdiConverter;

const headers835 = ["Notes", "Invoice", "Billing Date", "Date of Service", "LastName", "FirstName", "ID", "Claim Status", "Billing Amount", "Claim Number", "Amount Paid", "Date of Payment", "Check #", "Amount Due"];

const headers837 = ["date_of_service","pat_name_last","pat_name_first", "ins_number",	"pat_dob",	"pat_sex",	"pat_add",	"pat_city", "pat_state",	"pat_zip",	"procedure_code",	"modifier",	"units",	"charge",	"payer_id",	"total_charge",	"prior_auth",	"pickup_addr_1",	"pickup_addr_2",	"pickup_city",	"pickup_state",	"pickup_zip",	"dropoff_addr_1",	"dropoff_addr_2",	"dropoff_city",	"dropoff_state",	"dropoff_zip"]





// WEBPACK FOOTER //
// ./src/app/edi_converter/EdiConverter.js